import EnvironmentConfiguration from "../../../types/EnvironmentConfiguration";
import CollapsingDisabledMedicalQuestionDecorator from "../Components/CollapsingDisabledMedicalQuestionDecorator";
import NoElementFormItem from "../Components/NoElementFormItem";
import SideEffectMedicalQuestionDecorator from "../Components/SideEffectMedicalQuestionDecorator";
import YesNoToggleMedicalQuestion from "../Components/YesNoToggleMedicalQuestion";
import ComposableMedicalFormEvaluator, {
  IComposableMedicalFormEvaluatorConfig
} from "../types/ComposableMedicalFormEvaluator";
import IMedicalFormElementProps from "../types/IMedicalFormElement";
import IMedicalQuestionnaireCompleteEvaluator from "../types/IMedicalQualificationCompleteEvaluator";
import IMedicalQualificationNonCandidateEvaluator from "../types/IMedicalQualificationNonCandidateEvaluator";

const questionIds = {
  diabetic: "diabeticMedicalQuestions.diabetic"
};

const a1cDialogue: React.FC<IMedicalFormElementProps> = props =>
  NoElementFormItem({
    ...props,
    questionId: "diabeticMedicalQuestions.a1cDialogue",
    text: `Thank you. An A1C of ${EnvironmentConfiguration.a1cUpperLimit} or below is required for surgery. Please bring your most recent A1C reading to review during your consult.`,
    ChildFormItem: null
  });

const collapseA1CDialogueDecorator: React.FC<IMedicalFormElementProps> = props =>
  CollapsingDisabledMedicalQuestionDecorator({
    ...props,
    isDisabled: formState => formState[questionIds.diabetic] !== true,
    ChildFormItem: a1cDialogue
  });

const diabeticQuestion: React.FC<IMedicalFormElementProps> = props =>
  YesNoToggleMedicalQuestion({
    ...props,
    questionId: questionIds.diabetic,
    text: "Do you have diabetes?",
    ChildFormItem: collapseA1CDialogueDecorator
  });

const conclusionsDiabeticDecorator: React.FC<IMedicalFormElementProps> = props =>
  SideEffectMedicalQuestionDecorator({
    ...props,
    transformMedicalConclusions: (oldConclusions, newFormState) => ({
      ...oldConclusions,
      hasDiabetes: newFormState[questionIds.diabetic] === true
    }),
    transformMedicalFormState: null,
    ChildFormItem: diabeticQuestion
  });

export const DiabeticFormEvaluatorConfig: IComposableMedicalFormEvaluatorConfig = {
  allFormQuestionIds: Object.values(questionIds),
  requiredQuestionPredicates: null,
  nonCandidateIgnoredQuestionIds: [questionIds.diabetic],
  nonCandidateQuestionPredicates: null
};

export const DiabeticFormEvaluator: IMedicalQuestionnaireCompleteEvaluator &
  IMedicalQualificationNonCandidateEvaluator = new ComposableMedicalFormEvaluator(DiabeticFormEvaluatorConfig);

export const diabeticFormQuestions: React.FC<IMedicalFormElementProps>[] = [conclusionsDiabeticDecorator];
